<template>
  <div class="invite-member" v-if="!autoRedirect">
    <back-navigation-header :on-back="onBack"/>
    <img class="top-image" :src="require('@/assets/invite-member.svg')"/>
    <div class="content">
      <div>
        <div class="title">הוספת שותפ.ה למנוי RiseUp</div>
        <div class="text">
          <div>אפשר לקבל את ההחלטות הכלכליות ביחד.</div>
          מי שיצטרף אליך
          <span class="bold">יראה את המידע בתזרים, יקבל את כל ההודעות בדיוק כמוך, ללא תוספת תשלום.</span>
          <div>&nbsp;</div>
          <span class="bold">הכנו לך</span>
          <span class="preview" v-on:click="showPreview"> הודעת הזמנה אישית</span>,
          כל מה שצריך הוא לשלוח אותה ב-WhatsApp.
        </div>
      </div>
      <div class="footer-wrapper">
          <intercom-tool-tip :text="'לא הצלחת לצרף את השותפ.ה? '"
                             :handle-action="handleIntercomClickAction"
                             :event-source="componentName"
                             :message="`היי רייזאפ,
אני רוצה להוסיף שותפ.ה לתזרים שלי.
תוכלו לעזור לי?`">
          </intercom-tool-tip>
        <riseup-button class="button"
                       :icon="require('@/assets/whatsapp-icon.svg')"
                       :title="'הזמנה דרך WhatsApp'"
                       :action="inviteMember"/>
    </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseUI from 'base-ui';
import IntercomToolTip from '@/base-components/onboarding/IntercomToolTip';
import Segment from '../../../Segment';
import BackNavigationHeader from '../../../base-components/app-header/BackNavigationHeader.vue';
import InviteMemberHelpPopup from '../../../base-components/onboarding/help-popups/InviteMemberHelpPopup.vue';
import config from '../../../config';
import router from '../../../router';

export default {
  name: 'InviteMember',
  props: {
    autoRedirect: Boolean,
  },
  components: {
    IntercomToolTip,
    BackNavigationHeader,
    RiseupButton: BaseUI.RiseupButton,
  },
  created() {
    Segment.trackUserInteraction('JustInTimeCX_Shown', { source: this.componentName });
    if (this.autoRedirect) {
      this.redirect();
    }
  },
  computed: {
    ...mapState('session', ['inviteToken']),
    componentName() {
      return this.$options.name;
    },
    inviteMemberLink() {
      return `${config.get().elsaPublicUrl}/invite?inviteToken=${this.inviteToken}`;
    },
    inviteMemberMessage() {
      // eslint-disable-next-line max-len
      return encodeURIComponent(`היי! *נרשמתי ל-riseup!*\nאני מחכה לך בתזרים המשותף שלנו 🎯\nכל מה שצריך לעשות בשביל להצטרף אליי זה *ללחוץ על הלינק המצורף* 👇\n${this.inviteMemberLink}`);
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    onBack() {
      router.go(-1);
    },
    inviteMember() {
      Segment.trackUserInteraction('InviteMemberClicked');
      window.open(`https://api.whatsapp.com/send?text=${this.inviteMemberMessage}`, '_blank');
    },
    redirect() {
      Segment.trackUserInteraction('InviteMemberRedirected');
      window.location.replace(`https://api.whatsapp.com/send?text=${this.inviteMemberMessage}`);
    },
    showPreview() {
      Segment.trackUserInteraction('InviteMemberPreviewClicked');
      this.openModal({
        component: InviteMemberHelpPopup,
      });
    },
    handleIntercomClickAction() {
      Segment.trackUserInteraction('JustInTimeCX_Clicked', { source: this.componentName });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../node_modules/base-ui/src/scss/riseup-colors';
@import '../../../scss/mixins';

.invite-member {
  height: 100%;
  display: flex;
  flex-direction: column;

  .top-image {
    width: 100%;
  }

  .content {
    @include responsive-padding;
    @include responsive-padding-top-bottom;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    flex-grow: 1;

    .title {
      font-size: 22px;
      line-height: 28px;
      font-weight: bold;
      margin-bottom: 15px;
    }

    .text {
      font-size: 16px;
      line-height: 24px;
      .bold {
        font-weight: bold;
      }
      .preview {
        color: $riseup_blue;
        font-weight: bold;
        cursor: pointer;
        text-decoration: underline;
      }
    }

    .riseup-button {
      align-self: flex-end;
      margin-top: 30px;
      width: 100%;
      height: 72px;
    }
  }
}
</style>
